const style = (theme) => {
  const transition = `all 0.1s ${theme.easings['power3.out']}`

  const output = {
    root: {
      transition,
      display: 'block',
      position: 'relative',
      zIndex: 1,
      '&::before': {
        transition,
        content: '""',
        position: 'absolute',
        zIndex: 2,
        display: 'block',
        top: 0,
        left: 0,
        width: '100%',
        height: 1,
        background: theme.colors[5],
      },
      '&::after': {
        transition,
        content: '""',
        position: 'absolute',
        zIndex: 2,
        display: 'block',
        bottom: -1,
        left: 0,
        width: '100%',
        height: 1,
        background: theme.colors[5],
      },
    },

    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
    },
    imageWrapper: {
      width: '16%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    image: {
      transition,
      position: 'relative',
      zIndex: 1,
      width: '100%',
      paddingTop: 50,
      paddingBottom: 50,
      background: theme.colors[1],
      '&::before': {
        content: '""',
        zIndex: 1,
        display: 'block',
        top: 0,
        left: 0,
        width: '100%',
        paddingBottom: '72%',
      },
      '& img': {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        fontFamily: "'object-fit: contain;'",
        mixBlendMode: 'multiply',
      },
    },
    info: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      fontSize: 24,
      color: theme.colors[0],
      textTransform: 'uppercase',
      lineHeight: 1,
      paddingLeft: '7%',
      flex: 1,
    },
    iconLink: {
      position: 'absolute',
      left: '5%',
      width: 18,
      height: 18,
    },
    title: {
      fontWeight: 800,
    },
    denomination: {
      marginTop: 5,
      fontWeight: 300,
    },
    icon: {
      width: '15%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        transition: `all 0.3s ${theme.easings['power3.out']}`,
        opacity: 0,
        width: 12,
        height: 12,
        fill: theme.colors[0],
        transform: 'translateX(-20px)',
      },
    },
    hover: {
      background: theme.colors[5],
      '&::before': {
        opacity: 0,
      },
      '& $image': {
        background: theme.colors[5],
      },
      '& $icon': {
        '& svg': {
          opacity: 1,
          transform: 'translateX(0)',
        },
      },
    },


    // News
    news: {
      '& $wrapper': {
        extend: theme.wrapper,
      },
      '& $image': {
        width: '100%',
        paddingTop: 0,
        paddingBottom: 0,
        '& img': {
          mixBlendMode: 'normal',
          objectFit: 'cover',
          fontFamily: "'object-fit: cover;'",
        },
      },
    },

    // Art News
    artnews: {
      '&::before': {
        opacity: 0.4,
      },
      '&::after': {
        opacity: 0.4,
      },
      '& $wrapper': {
        extend: theme.wrapper,
      },
      '& $image': {
        width: '100%',
        paddingTop: 0,
        paddingBottom: 0,
        '& img': {
          mixBlendMode: 'normal',
          objectFit: 'cover',
          fontFamily: "'object-fit: cover;'",
        },
      },
      '& $info': {
        color: theme.colors[1],
      },
      '& $iconLink': {
        fill: theme.colors[1],
      },
      '&$hover': {
        background: theme.getRgba(theme.colors[0], 0.1),
        '& $image': {
          background: theme.getRgba(theme.colors[0], 0.1),
        },
      },
      '& $icon': {
        '& svg': {
          fill: theme.colors[1],
        },
      },
    },

  }
  output[theme.mediaInverse.md] = {
    image: {
      width: '100%',
    },
    info: {
      fontSize: 18,
    },
    icon: {
      '& svg': {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      marginBottom: '0 !important',
    },
    wrapper: {
      padding: '0 6vw',
      flexWrap: 'wrap',
    },
    iconLink: {},

    news: {
      '& $wrapper': {
        flexWrap: 'nowrap',
        paddingLeft: 30,
        paddingRight: 30,
      },
      '& $image': {
        '& img': {
          left: 0,
          top: 0,
        },
      },
      '& $imageWrapper': {
        width: '30%',
      },
      '& $info': {
        marginBottom: 0,
        paddingLeft: 30,
      },
      '& $iconLink': {
        width: 10,
        height: 10,
      },
      '& $title': {
        textAlign: 'left',
      },
      '& $icon': {
        marginBottom: 0,
      },
    },

    artnews: {
      '& $wrapper': {
        flexWrap: 'nowrap',
        paddingLeft: 30,
        paddingRight: 30,
      },
      '& $image': {
        '& img': {
          left: 0,
          top: 0,
        },
      },
      '& $imageWrapper': {
        width: '30%',
      },
      '& $info': {
        marginBottom: 0,
        paddingLeft: 30,
      },
      '& $iconLink': {
        width: 10,
        height: 10,
      },
      '& $title': {
        textAlign: 'left',
      },
      '& $icon': {
        marginBottom: 0,
      },
    },

    imageWrapper: {
      width: '100%',
      margin: '0 auto',
    },
    image: {
      paddingTop: 20,
      paddingBottom: 20,
      width: '60%',
    },
    info: {
      fontSize: 14,
      marginBottom: 25,
      paddingLeft: 0,
    },
    icon: {
      display: 'none',
    },
  }


  return output
}

export default style
